import React from 'react'
import { AgTechWebApplication } from '../../../application/AgTechWebApplication'

const AgTechWebAppBackdrop = (props: { app: AgTechWebApplication, children: JSX.Element }) => {
    return (
        <div className="bg-primary stretched centered bg-cover flex" style={{
            backgroundImage: `url(${props.app.backgroundImage})`
        }}>
            <div className="stretched centered row-based bg-tinted flex">
                <div className="row-based items-center justify-end flex">
                    <i className={`text-white text-[56px] opacity-0 animate-[fadeIn_1000ms_forwards_500ms] mb-6 fas fa-${props.app.icon}`} />
                    <h1 className="text-white text-[44px] opacity-0 animate-[fadeIn_1000ms_forwards_500ms] font-orbitron">{props.app.name}</h1>
                </div>
                <div className="row-based text-white opacity-0 animate-[fadeIn_1000ms_forwards_500ms] mt-[150px] mb-[40px] container">
                    {props.children}
                </div>
            </div>
        </div>
    )
}

export default AgTechWebAppBackdrop